import { BenutzerDetailApiDto, BenutzerInfoSearchResultApiDto } from '@/api-schema';
import { BenutzerInfoSearchApiDto } from '@/types/BenutzerInfoSearchApiDto';
import { TeilnehmerBenutzerDto } from '@/types/UserDtos';

export interface ILieferantEinstellungenState {
    benutzerFilter: BenutzerInfoSearchApiDto;
    benutzerInfoSearchResultApiDto: BenutzerInfoSearchResultApiDto;
    benutzerTotalNumberOfRecords: number | null;
    benutzerLoading: boolean;
    benutzerDetails: BenutzerDetailApiDto;
    lieferantBenutzerData: Array<TeilnehmerBenutzerDto>;
}

export const state: ILieferantEinstellungenState = {
    benutzerFilter: new BenutzerInfoSearchApiDto(),
    benutzerInfoSearchResultApiDto: null,
    benutzerTotalNumberOfRecords: null,
    benutzerLoading: false,
    benutzerDetails: {},
    lieferantBenutzerData: []
};
